
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { SidebarFooter as Footer } from '@/components/ui/sidebar';
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import { Button } from '@/components/ui/button';
import { LogOut } from 'lucide-react';
import { useAuth } from '@/contexts/AuthContext';
import { useSidebar } from '@/components/ui/sidebar';
import { useCourierInfo } from '@/pages/courier/hooks/useCourierInfo';

export const SidebarFooter: React.FC = () => {
  const { user, logout } = useAuth();
  const { courierName } = useCourierInfo();
  const navigate = useNavigate();
  const { state } = useSidebar();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <Footer className="mt-auto border-t border-white/10 p-4 bg-gradient-to-r from-tuktuk-teal/30 to-teal-900/50">
      <div className="flex items-center justify-between">
        <div className="flex items-center space-x-3">
          <Avatar className="h-10 w-10 border-2 border-tuktuk-teal/50">
            <AvatarImage src={user?.avatar} alt={user?.name} />
            <AvatarFallback className="bg-gradient-to-br from-tuktuk-teal to-teal-600 text-white">
              {user?.name ? user.name.charAt(0) : 'У'}
            </AvatarFallback>
          </Avatar>
          {state === 'expanded' && (
            <div className="flex flex-col">
              <p className="text-base font-medium uppercase text-white">{courierName || user?.name || 'Пользователь'}</p>
              <p className="text-xs text-white/70">{user?.role === 'admin' ? 'Администратор' : 'Курьер'}</p>
            </div>
          )}
        </div>
        <Button
          variant="ghost"
          size="icon"
          onClick={handleLogout}
          title="Выйти"
          className="text-white/70 hover:text-white hover:bg-red-500/20"
        >
          <LogOut className="h-5 w-5" />
        </Button>
      </div>
    </Footer>
  );
};
